import { getErrorMessage } from "../../../util"
export const getAllImportErrors = ({ state, commit, dispatch, rootState }, query) => {
    commit('toggleLoadingImportErrors', true)
    const dispatchGetImports = () => {
        return dispatch('get', {
            url : '/provider/' + state.id + '/import',
            query
        }, { root: true }).then((response) => {
            commit('toggleLoadingImportErrors', false)
            commit('setImportMapping', response.map)
            commit('setImportErrors', response.records.filter((rec) => rec && rec.problem.length > 0 && !rec.problem.find(p => p.key.indexOf("same_schedule") > -1  || p.key.indexOf("email:empty")  > -1)).map((obj) => {
                if(obj.transform && !obj.transform.event) {
                    obj.transform.event = {}
                }
                return {
                    data: obj,
                    error: null
                }
            }))
        }).catch(err => {
            console.log(err)
            commit('toggleLoadingImportErrors', false)
            commit('setImportErrors', [])
        })
    }
    
    setTimeout(dispatchGetImports, 5000)
}

export const ignoreImportError = ({ state, commit, dispatch, rootState }, query = { record: []}) => {
    const ids = query.record.map(o => o.key.id)
    commit('setRecordIdsForIgnoringImportError', ids)
    return dispatch('patch', {
        url: "/provider/" + state.id + '/import',
        data: {
            ...query
        }
    }, { root: true }).then((response) => {
        commit('finishLoading')
        commit('setRecordIdsForIgnoringImportError', [])
        commit('setImportErrors', rootState.provider.importErrors.filter((record) => {
            if(ids.indexOf(record.data.id) < 0) {
                return record
            }
        }))
    }).catch(err => {
        console.log(err)
        commit('finishLoading')
        commit('setRecordIdsForIgnoringImportError', [])
        commit('ignoringImportErrorFailure', query)
    })
}

export const resolveImportErrors = ({ state, commit, dispatch, rootState }, query = { record: []}) => {
    const providers = rootState.provider.providers.reduce((acc, provider) => {
        acc.push(provider.provider)
        return acc
    }, [])
    const provider = state.id || state.providers[0]["provider"]
    commit('setRecordIdsForIgnoringImportError', query.record.map(o => o.key.id))
    return dispatch('post', {
        url: "/provider/" + provider + '/import',
        data: {
            ...query,
            provider,
            providers
        }
    }, { root: true }).then((response) => {
        commit('finishLoading')
        commit('setRecordIdsForIgnoringImportError', [])
        if(response.error) {
            const errorMessagesMap = response.data.reduce((acc, record) => {
                acc[record.key.id] = getErrorMessage(record.error)
                return acc
            }, {})
            console.log(errorMessagesMap)
            commit('setImportErrors', rootState.provider.importErrors.map(record => {
                record.error = errorMessagesMap[record.data.id]
                return record
            }))
        } else {
            const successIds = response.resolution.filter((res) => !res.error).map((res) => res.id)
            commit('setImportErrors', rootState.provider.importErrors.filter((record) => {
                if(successIds.indexOf(record.data.id) < 0) {
                    return record
                }
            }))
            commit('setResolvedErrorCount', successIds.length)
            setTimeout(() => {
                commit('setResolvedErrorCount', 0)
            }, 3000)
            providers.forEach(providerId => {
                dispatch('loadLineup', { id: providerId })
            })
        }
    }).catch(err => {
        console.log(err)
        commit('finishLoading')
        commit('setRecordIdsForIgnoringImportError', [])
    })
}